module.exports = __webpack_public_path__ + "img/11.6ef28cbf.jpg";